module.exports = __webpack_public_path__ + "static/media/freeukgen.336ff268.png";